import React, { useEffect, useState } from "react";
import Loader from "./Loader";
import {
  Alert,
  Snackbar,
  Tooltip,
} from "@mui/material";
import { Helmet } from "react-helmet";
import Header from "./Header";
import Title from "./utils/Title/Title";
import {
  ArrowForward,
  AutoAwesomeOutlined,
  CloseOutlined,
  DeleteOutline,
  DescriptionOutlined,
  FileUploadOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import "./AiAssessmentDashboard.css";
import CustomModal from "./utils/CustomModal/CustomModal";
import { listAssessment, deleteAssessment } from "../../services/assessmentService";

function GeneratedAssessments() {
  const [showLoader, setShowLoader] = useState(false);


  const [assessmentList, setAssessmentList] = useState([]);

  const [openToast, setOpenToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [severityClass, setSeverityClass] = useState("success");
  const handleCloseToast = () => {
    setOpenToast(false);
  };

  // file
  const [selectedFile, setSelectedFile] = useState(null);

  // assessment
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [openAssessmentEditModal, setOpenAssessmentEditModal] = useState(false);
  const [openAssessmentDeleteModal, setOpenAssessmentDeleteModal] = useState(false);
  const [openAssessmentGenerateModal, setOpenAssessmentGenerateModal] = useState(false);
  const [prompt, setPrompt] = useState("");
  const [numberOfQuestions, setNumberOfQuestions] = useState(10);
  const [totalMarks, setTotalMarks] = useState(100);
  const [passingMarks, setPassingMarks] = useState(40);
  const [assessmentType, setAssessmentType] = useState("MCQ");
  const [assessmentName, setAssessmentName] = useState("");
  const [assessmentDescription, setAssessmentDescription] = useState("");
  const [assessmentDuration, setAssessmentDuration] = useState(60);


  const handleOpenEditAssessmentModal = (assessment) => {
    try {
      setShowLoader(true)
      console.log(assessment)

      if(!assessment) throw new Error("Assessment not found")
      if(!assessment.aiCardItemid) throw new Error("Assessment Id not found")
      if(!assessment.name) throw new Error("Assessment name not found")

      setSelectedAssessment(assessment);
      setOpenAssessmentEditModal(true);

    } catch (error) {
      console.error("Error (handleOpenEditAssessmentModal) : ", error)
      setToastMsg("Something went wrong"); 
      setSeverityClass("error");
      setOpenToast(true);
    }finally{
      setShowLoader(false)
    }
  }
  const handleCloseDeleteAssessmentModal = () => {
    setOpenAssessmentDeleteModal(false);
  };
  const handleOpenDeleteAssessmentModal = (assessment) => {
    try {
      setShowLoader(true)
      console.log(assessment)

      if(!assessment) throw new Error("Assessment not found")
      if(!assessment.aiCardItemid) throw new Error("Assessment Id not found")
      if(!assessment.name) throw new Error("Assessment name not found")

      setSelectedAssessment(assessment);
      setOpenAssessmentDeleteModal(true);

    } catch (error) {
      console.error("Error (handleOpenDeleteAssessmentModal) : ", error)
      setToastMsg("Something went wrong"); 
      setSeverityClass("error");
      setOpenToast(true);
    }finally{
      setShowLoader(false)
    }
  }
  const handleAssessmentDelete = async () => {
    try {
      setShowLoader(true)
      console.log("Delete Assessment : ", selectedAssessment)
      if(!selectedAssessment) throw new Error("Assessment not found")
      if(!selectedAssessment.aiCardItemid) throw new Error("Assessment Id not found")
      if(!selectedAssessment.name) throw new Error("Assessment name not found")

      // Call delete assessment API

      const response = await deleteAssessment(selectedAssessment.aiCardItemid);
      console.log(response);
      if (response.status !== 200) throw new Error("Something went wrong")

      // Update the assessment list
      const updatedAssessmentList = assessmentList.filter((assessment) => assessment.aiCardItemid !== selectedAssessment.aiCardItemid);
      setAssessmentList(updatedAssessmentList);
      setSelectedAssessment(null);
      setToastMsg("Assessment Deleted Successfully");
      setSeverityClass("success");
      setOpenToast(true);
    }
    catch (error) {
      console.error("Error (handleAssessmentDelete) : ", error)
      setToastMsg("Something went wrong"); 
      setSeverityClass("error");
      setOpenToast(true);
    }
    finally {
      setOpenAssessmentDeleteModal(false);
      setShowLoader(false)
    }
  };

  const fetchAssessmentList = async () => {
    try {
      setShowLoader(true)
      const response = await listAssessment();
      console.log(response);
      if (response.status !== 200) return

      setAssessmentList(response.data.data.assessments);
      
    } catch (error) {
      console.error("Error (fetchAssessmentList) : ", error)
      setToastMsg("Something went wrong");
      setSeverityClass("error");
      setOpenToast(true);
    }
    finally {
      setShowLoader(false)
    }
  }

  useEffect(() => {
    const init = async () => {
      await fetchAssessmentList();
    }
    init();
  },[])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Generated Assessment</title>
      </Helmet>
      <Header />
      <Loader visible={showLoader} />

      <Snackbar
        open={openToast}
        autoHideDuration={3500}
        onClose={handleCloseToast}
      >
        <Alert
          variant="filled"
          onClose={handleCloseToast}
          severity={severityClass}
          sx={{ width: "100%" }}
        >
          {toastMsg}
        </Alert>
      </Snackbar>

      {/* Delete Assessment Modal*/}
      <CustomModal
        open={openAssessmentDeleteModal}
        handleClose={handleCloseDeleteAssessmentModal}
      >
        <h3
          style={{
            color: "#8cc63c",
          }}
        >
          Delete Assessment
        </h3>
        <div className="modal green" style={{ margin: "20px 0" }}>
          <p>Selected Assessment: </p>
          <div className="selected_file">
            <DescriptionOutlined />
            <span>{ selectedAssessment?.name || "No Assessment Selected" }</span>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <button
            style={{
              backgroundColor: "#8cc63c",
              color: "white",
              padding: "5px 7px",
              border: "none",
              borderRadius: "7px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              cursor: "pointer",
              fontSize: "14px",
            }}
            onClick={handleCloseDeleteAssessmentModal}
          >
            <span>Cancel</span>
            <CloseOutlined style={{ fontSize: "16px" }} />
          </button>
          <button
            style={{
              backgroundColor: "#E33232",
              color: "white",
              padding: "5px 7px",
              border: "none",
              borderRadius: "7px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              cursor: "pointer",
              fontSize: "14px",
            }}
            onClick={handleAssessmentDelete}
          >
            <span>Delete</span>
            <DeleteOutline style={{ fontSize: "16px" }} />
          </button>
        </div>
      </CustomModal>

      {/* View Assessment Modal */}
      <CustomModal
        open={openAssessmentEditModal}
        handleClose={() => setOpenAssessmentEditModal(false)}
      >
        <h3
          style={{
            color: "#8cc63c",
          }}
        >
          {selectedAssessment?.name || "No Assessment Selected"}
        </h3>
        <div className="modal teal generate_assessment_modal" style={{ margin: "20px 0" }}>
          <div className="input_row">
            <div className="input_wrapper">
              <label>File</label>
              <div className="selected_file">
                <DescriptionOutlined />
                <span>{selectedAssessment?.pdfDetails?.name || "No File Selected"}</span>
              </div>
            </div>
            <div className="input_wrapper">
              <label>Assessment Type</label>
              <select className="input_text select" value={0} onChange={(e) => setAssessmentType(e.target.value)}>
                <option value='default'>Select Assessment Type</option>
                <option value={0}>MCQ</option>
                <option value={1}>Fill in the Blanks</option>
                <option value={2}>True or False</option>
                <option value={5}>Descriptive</option>
              </select>
            </div>
          </div>
      
          <div className="input_row">
            <div className="input_wrapper">
              <label>Assessment Name</label>
              <input
                type="text"
                className="input_text"
                placeholder="Maths - Know your Numbers - level 1"
                value={selectedAssessment?.name || ""}
                onChange={(e) => setAssessmentName(e.target.value)}
              />
            </div>
            <div className="input_wrapper">
              <label>Assessment Description</label>
              <input
                type="text"
                className="input_text"
                placeholder="Structured Assessment for level 1"
                value={selectedAssessment?.description || ""}
                onChange={(e) => setAssessmentDescription(e.target.value)}
              />
            </div>
          </div>

          <div className="input_row">
            <div className="input_wrapper">
              <label>Number Of Questions</label>
              <select className="input_text select" value={selectedAssessment?.questions.length} onChange={(e) => setNumberOfQuestions(e.target.value)}>
                <option value='default'>Select Number of Questions</option>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
              </select>
            </div>
            <div className="input_wrapper">
              <label>Duration</label>
              <select className="input_text select" value={selectedAssessment?.duration} onChange={(e) => setAssessmentDuration(e.target.value)}>
                <option value='default'>Select Duration</option>
                <option value={15}>15 minutes</option>
                <option value={30}>30 minutes</option>
                <option value={60}>1 hour</option>
                <option value={120}>2 hours</option>
                <option value={180}>3 hours</option>
              </select>
            </div>
          </div>

          <div className="input_row">
            <div className="input_wrapper">
              <label>Total Marks</label>
              <input
                type="number"
                className="input_text"
                placeholder="Total Marks"
                value={selectedAssessment?.totalMarks}
                onChange={(e) => setTotalMarks(e.target.value)}
              />
            </div>
            <div className="input_wrapper">
              <label>Passing Marks</label>
              <input
                type="number"
                className="input_text"
                placeholder="Passing Marks"
                value={selectedAssessment?.passingMarks}
                onChange={(e) => setPassingMarks(e.target.value)}
              />
            </div>
          </div>

          <div className="input_wrapper">
            <label>Prompt</label>
            <textarea
              className="input_text"
              placeholder="Enter your prompt here"
              value={selectedAssessment?.prompt || ""}
              onChange={(e) => setPrompt(e.target.value)}
            >
            </textarea>
          </div>

          {/* <div className="mcq_question_block">
            <p className="question" >What is 2+2?</p>
            <div className="options" >
              <div className="option" ><span>1.</span>1</div>
              <div className="option" ><span>2.</span>2</div>
              <div className="option" ><span>3.</span>3</div>
              <div className="option" ><span>4.</span>4</div>
            </div>
            <div className="answer" ><span>Correct Answer :</span>4. 4</div>
          </div> */}

          {selectedAssessment?.questions?.map((question, index) => (
            <div className="mcq_question_block" key={question.id}>
              <p className="question">{index + 1}. {question.question}</p>
              <div className="options">
                {question.options.map((option, index) => (
                  <div className="option" key={index}>
                    <span>{index + 1}.</span>
                    {option}
                  </div>
                ))}
              </div>
              <div className="answer">
                <span>Correct Answer :</span>
                {question.options[question.correct_answer]}
              </div>
            </div>
          ))}

        </div>
        <div
          style={{
            width: "100%",
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <button
            style={{
              backgroundColor: "#04a5a6",
              color: "white",
              padding: "5px 7px",
              border: "none",
              borderRadius: "7px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              cursor: "pointer",
              fontSize: "14px",
            }}
            onClick={() => setOpenAssessmentEditModal(false)}
          >
            <span>Close</span>
            <CloseOutlined style={{ fontSize: "16px" }} />
          </button>
          <button
            style={{
              backgroundColor: "#04a5a6",
              color: "white",
              padding: "5px 7px",
              border: "none",
              borderRadius: "7px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              cursor: "pointer",
              fontSize: "14px",
            }}
            onClick={() => {
              setOpenAssessmentEditModal(false);
              setOpenAssessmentGenerateModal(true);
            }}
          >
            <span>Generate</span>
            <AutoAwesomeOutlined style={{ fontSize: "16px" }} />
          </button>
        </div>
      </CustomModal>

      {/* Starts from here*/}
      <div className="custom_container">
        <Title>Generated Assessments</Title>

        {/* view recently generated assessments  */}
        <section
          className="generated_assessments card_section"
          style={{
            padding: "20px 0",
            margin: "20px 0",
          }}
        >
          <div
            className="generated_assessments_wrapper"
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              marginTop: "10px",
              gap: "30px",
              flexWrap: "wrap",
            }}
          >
            {assessmentList.map((assessment) => (
              <div className="card assessment" key={assessment.aiCardItemid}>
                <div className="summary" style={{ fontWeight: "600" }}>
                  <p>Total Questions - {assessment.questions.length}</p>
                  <p>Type - {assessment.type === "0" ? 'MCQ' : assessment.type}</p>
                  <p>Total Marks - {assessment.totalMarks}</p>
                  <p>Passing Marks - {assessment.passingMarks}</p>
                  <p>Duration - {assessment.duration + ' Minutes'} </p>
                </div>
                <div className="bottom_bar">
                  <div className="name">{assessment.name}</div>
                  <div className="actions">
                    <Tooltip title="View Assessment">
                      <VisibilityOutlined className="action_btn" onClick={()=>{ handleOpenEditAssessmentModal(assessment) }} />
                    </Tooltip>
                    <Tooltip title="Delete Assessment">
                      <DeleteOutline
                        className="action_btn red"
                        onClick={() => {
                          handleOpenDeleteAssessmentModal(assessment);
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}

export default GeneratedAssessments;
